import {
  OrganizationPayload,
  SearchOrganizationsPayload,
} from "@/domain/organizations.interface";
import { OrganizationService } from "../../services/organizations.service";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useOrganizationList = () => {
  const {
    data,
    isLoading: isLoadingOrganizations,
    refetch: refetchOrganizations,
  } = useQuery({
    queryKey: ["coyn-organizations-list"],
    queryFn: () => OrganizationService.findAll(),
  });

  return {
    data,
    isLoadingOrganizations,
    refetchOrganizations,
  };
};

export const useGetOrganizations = (
  {
    search,
    sortField,
    sortOrder,
    pageNumber,
    pageSize,
  }: SearchOrganizationsPayload = {
    search: "",
    pageNumber: 0,
    pageSize: 100,
    sortField: "name",
    sortOrder: 1,
  },
) => {
  const {
    data,
    isLoading: isLoadingOrganizations,
    refetch: refetchOrganizations,
  } = useQuery({
    queryKey: ["coyn-organizations-manage-list"],
    queryFn: () =>
      OrganizationService.search({
        search,
        sortField,
        sortOrder,
        pageNumber,
        pageSize,
      }),
  });

  return {
    data,
    isLoadingOrganizations,
    refetchOrganizations,
  };
};

export const useGetOUGroupLabels = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["coyn-ou-grouplabels"],
    queryFn: () => OrganizationService.findOrganizationGroupLabels(),
  });

  return {
    data,
    isLoading,
  };
};

export const useCreateOrganization = () => {
  return useMutation({
    mutationFn: (data: OrganizationPayload) => OrganizationService.create(data),
  });
};

export const useUpdateOrganization = () => {
  return useMutation({
    mutationFn: (payload: { id: string; data: OrganizationPayload }) =>
      OrganizationService.update({
        id: payload.id,
        data: payload.data,
      }),
  });
};

export const useDeleteOrganization = () => {
  return useMutation({
    mutationFn: (id: string) => OrganizationService.softDelete(id),
  });
};
